module.exports = __webpack_public_path__ + "img/our-mission.d9749082.png";